module.exports = __webpack_public_path__ + "static/media/job match score - mamaging previous scans.626852dc.png";